import React from 'react';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import { AnchorWithLink } from 'atoms/Anchor';
import ImageComponent from 'atoms/Image';
import { showLoginLinkForNonLoggedInUsers } from './DispositionModuleUtils/DispositionModuleUtils';
import { singInClickhandler } from '../SearchStoreUtilities/SearchStoreUtils';
import { IMAGE_PATH } from 'common/ImageConstants/ImagePathUtils';
const { LocationImage } = IMAGE_PATH;

const SignInAndCurrentLocationSectionComp = props => {
  const {
    loggedIn = false,
    formContent = {},
    useCurrentLocation,
    storeSelection,
    hideLocationLink,
    showLocationConfirmModal,
  } = props;
  const { signInLink, useMyLocation } = storeSelection;
  const { memberText = '', singInLink = {}, currentLocationText = '' } = formContent;
  return (
    <div className='login-section'>
      {signInLink && (
        <span className='delivery-member-signin'>
          {!loggedIn && showLoginLinkForNonLoggedInUsers(memberText, singInClickhandler, singInLink)}
        </span>
      )}
      {useMyLocation && (
        <span className={`${showLocationConfirmModal ? 'disable-location-link' : ''}`}>
          <AnchorWithLink
            onClickHandler={useCurrentLocation}
            className={`delivery-location-link${hideLocationLink ? ' hide-location-link' : ''}`}
            data-testid='use-my-location'
          >
            <ImageComponent data-testid='' srcFile={LocationImage} alt=' ' className='location-img' />
            {translateWithI18Next(currentLocationText)}
          </AnchorWithLink>
        </span>
      )}
    </div>
  );
};

export const SignInAndCurrentLocationSection = React.memo(SignInAndCurrentLocationSectionComp);
